// @dynamic-i18n-keys
// deviationSubmit.form.app.oauth2RedirectWhitelist.hint.*
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import Textarea from '@wix/da-shared-react/pkg/Textarea';
import { useSubmitField } from '../../../hooks/useSubmitField';
import { SubmitFormContext } from '../../../context';
import { OAuth2GrantType } from '../OAuthGrantTypeField';

import s from './OAuthRedirectUriField.scss';

const OAuthRedirectUriField: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { initResponse } = useContext(SubmitFormContext) ?? {};
  const {
    id,
    field: { onChange, value },
  } = useSubmitField('oauth2RedirectWhitelist', {
    initAdapter: ({ app }) => app?.oauth2RedirectWhitelist ?? '',
    submitAdapter: ({ oauth2RedirectWhitelist }) => ({
      oauth2_redirect_whitelist: oauth2RedirectWhitelist,
    }),
  });

  const { watch } = useFormContext();
  const grantType = watch('oauth2GrantType') ?? OAuth2GrantType.AUTHORIZATION_CODE;
  const oauth2Upgrade21 = watch('oauth2Upgrade21');
  const isOauth20 = initResponse?.app?.isOauth20;
  const isLegacyMode = isOauth20 === false || oauth2Upgrade21 === true;
  const hintKey = isLegacyMode
    ? 'deviationSubmit.form.app.oauth2RedirectWhitelist.hint.implicit'
    : `deviationSubmit.form.app.oauth2RedirectWhitelist.hint.${grantType}`;

  return (
    <Textarea
      id={id}
      label={t('deviationSubmit.form.app.oauth2RedirectWhitelist.label')}
      subLabel={t(hintKey)}
      onChange={onChange}
      value={value}
      textareaClassName={s['textarea']}
      isRequired
    />
  );
};
OAuthRedirectUriField.displayName = 'OAuthRedirectUriField';

export default OAuthRedirectUriField;
